import { render, staticRenderFns } from "./TreeStructureAdd.vue?vue&type=template&id=58ba35e1"
import script from "./TreeStructureAdd.vue?vue&type=script&lang=js"
export * from "./TreeStructureAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports